"use client";

import { cn } from "~/lib/utils";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function Logo({
  className,
  fill,
}: {
  className?: string;
  fill?: string;
}) {
  const { theme } = useTheme();
  const [themeFill, setThemeFill] = useState("#fff");

  // Needed to prevent Hydration errors
  useEffect(() => {
    if (theme === "dark") {
      setThemeFill("#fff");
    } else {
      setThemeFill("#333");
    }
  }, [theme]);

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="36 36 696 696"
      preserveAspectRatio="xMidYMid meet"
      className={cn("h-8 w-8", className)}
    >
      <path
        d="M0,0 L132,0 L134,1 L134,405 L132,441 L128,464 L122,485 L116,500 L107,519 L94,539 L83,553 L77,560 L75,560 L73,564 L69,566 L67,570 L56,579 L45,588 L21,603 L-2,614 L-26,623 L-39,627 L-63,632 L-85,635 L-93,636 L-112,637 L-141,637 L-167,635 L-190,632 L-221,625 L-244,617 L-253,613 L-253,611 L-245,611 L-233,613 L-219,614 L-206,614 L-183,612 L-161,608 L-139,601 L-126,596 L-111,588 L-100,582 L-83,570 L-72,561 L-67,556 L-65,556 L-65,554 L-63,554 L-63,552 L-59,548 L-57,548 L-55,544 L-46,534 L-35,518 L-27,505 L-19,488 L-14,477 L-6,450 L-2,428 L0,405 L0,135 L-11,139 L-34,150 L-61,162 L-77,170 L-88,175 L-93,174 L-93,51 L-92,43 L-65,30 L-49,23 L-26,12 Z "
        fill={fill ?? themeFill}
        transform="translate(503,66)"
      />
      <path
        d="M0,0 L4,0 L5,399 L8,424 L14,442 L22,459 L30,470 L37,478 L37,480 L41,482 L51,491 L66,500 L81,507 L98,512 L110,514 L123,515 L139,515 L153,514 L169,511 L183,507 L199,499 L213,490 L215,490 L213,495 L204,510 L195,521 L186,531 L178,540 L167,549 L159,555 L144,565 L125,575 L104,583 L90,587 L66,591 L27,591 L-3,586 L-20,581 L-40,573 L-55,565 L-67,556 L-81,544 L-90,533 L-97,523 L-106,507 L-111,496 L-117,480 L-122,464 L-126,444 L-128,424 L-129,379 L-129,63 L-126,60 L-97,46 L-63,30 L-36,17 L-14,7 Z "
        fill={fill ?? themeFill}
        transform="translate(245,70)"
      />
    </svg>
  );
}
